<!-- ClassDiagram.vue -->
<template>
  <div class="overlay" v-if="loading">
    <div class="loading-spinner"></div>
  </div>
  <div class="overlay" v-if="viewGuide">
    <div class="input-area guide">{{ $t('guide.input') }}</div>
    <div class="limit-area guide">{{ $t('guide.limit') }}</div>
    <div class="language-area guide">{{ $t('guide.language') }}</div>
    <div class="control-area guide">{{ $t('guide.control') }}</div>
    <div class="title-area guide">{{ $t('guide.title') }}</div>
    <div class="fitScreen-area guide">{{ $t('guide.fitScreen') }}</div>
    <div class="main-area guide">{{ $t('guide.main') }}</div>
    <div class="help-area guide">{{ $t('guide.help') }}</div>
    <div class="action-area guide">
      <div style="margin-bottom: 5px; text-align: left">
        {{ $t('guide.action') }}
      </div>
      <el-button type="primary" @click="viewDocument">{{ $t('guide.button1') }}</el-button>
      <el-button type="primary" @click="finishGuide">{{ $t('guide.button2') }}</el-button>
    </div>
  </div>
  <el-dialog :show-close="false" v-model="showDialog" :title="$t('attention')" width="500" align-center>
    <div>{{ $t('registerAlert') }}</div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="login">{{ $t('register') }} </el-button>
      </div>
    </template>
  </el-dialog>
  <HorizontalDraggableLayout class="layout" :showLeft="true" :showRight="true">
    <template #left>
      <div :class="['top', { 'dark-mode': isDarkMode, outQuota: requestQuotaData?.remain == 0 }]">
        {{ requestQuota }}
        <el-icon class="info"
          ><el-tooltip class="box-item" effect="dark" placement="top-start"
            ><template #content>
              <div>
                <a class="restiction" href="/document/class-diagram#limitation" target="_blank">{{
                  $t('restrictionInfo')
                }}</a>
              </div> </template
            ><QuestionFilled /></el-tooltip
        ></el-icon>
      </div>
      <div class="chat" ref="chatContainerRef">
        <ChatBubble :messages="chatsContent" @messageAction="messageAction" />
      </div>
      <div class="bottom">
        <div class="input-container">
          <div class="left">
            <el-input
              ref="textareaRef"
              type="textarea"
              :rows="1"
              :placeholder="$t('chat.pleaseInput')"
              v-model="textarea"
              :autosize="autosize"
              @keydown="handleKeyDown"
              @input="handleInput"
              :disabled="false"
              maxlength="128"
              show-word-limit
            ></el-input>
            <div class="input-length-info">
              <span v-if="isMaxLengthReached" class="max-length-warning">{{ $t('chat.maxLengthReached') }}</span>
            </div>
          </div>
          <div>
            <el-button
              type="primary"
              class="submit-button"
              @click="handleSubmit"
              :loading="submitLoading"
              :disabled="isSubmitButtonDisabled"
              :icon="ChatSquare"
              circle
            ></el-button>
            <el-button
              class="submit-button"
              @click="handleClean"
              :disabled="isSubmitButtonDisabled"
              :icon="DeleteFilled"
              circle
            ></el-button>
          </div>
        </div>
        <div class="powered">
          <div></div>
          <div class="helper">
            <transition name="fade">
              <div v-if="currentMessage" class="message" @click="handleMessageClick">{{ currentMessage }}</div>
            </transition>
          </div>
          <div class="help" @click="goToHelpPage">{{ $t('help') }}</div>
        </div>
      </div>
    </template>
    <template #right>
      <CanvasContainer :showCanvas="showCanvas" />
      <MarkdownContent :showDocument="!showCanvas" />
    </template>
    <template #others>
      <ToolBar
        :isMerged="isMerged"
        :showCanvas="showCanvas"
        @toggle-content="toggleContent"
        @icon-click="handleIconClick"
      />
      <el-dialog v-model="dialogVisible" :title="$t('operation.export')" width="30%" center align-center>
        <div class="dialog-content">
          <div class="dialog-row">
            <div class="dialog-label">{{ $t('operation.document') }}</div>
            <div class="icon-group">
              <el-icon @click="handleExport('DOCX')"
                ><svg
                  class="icon"
                  width="200px"
                  height="200.00px"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#1296db"
                    d="M354.40128 0c-87.04 0-157.44 70.55872-157.44 157.59872v275.68128H78.72c-21.6576 0-39.36256 17.69984-39.36256 39.36256v236.31872c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.24128v118.08256c0 87.04 70.4 157.59872 157.44 157.59872h472.63744c87.04 0 157.59872-70.55872 157.59872-157.59872V315.0336c0-41.74848-38.9888-81.93024-107.52-149.27872l-29.11744-29.12256L818.87744 107.52C751.5392 38.9888 711.39328 0 669.59872 0H354.4064z m0 78.72h287.20128c28.35456 7.0912 27.99616 42.1376 27.99616 76.8v120.16128c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.07744c39.38816 0 78.87872-0.0256 78.87872 39.36256v512c0 43.32032-35.55328 78.87872-78.87872 78.87872H354.4064c-43.32544 0-78.72-35.5584-78.72-78.87872v-118.08256h393.91744c21.66272 0 39.36256-17.69472 39.36256-39.35744V472.64256c0-21.66272-17.69984-39.36256-39.36256-39.36256H275.68128V157.59872c0-43.32032 35.39456-78.87872 78.72-78.87872zM308.6336 498.07872c23.04 0 41.28256 8.00256 54.72256 24.00256 14.08 15.36 21.12 37.43744 21.12 66.23744 0 29.44-7.04 51.84-21.12 67.2-13.44 15.36-31.68256 23.04-54.72256 23.04-23.68 0-42.24-7.35744-55.68-22.07744-13.44-15.36-20.15744-38.08256-20.15744-68.16256 0-29.44 6.71744-51.84 20.15744-67.2s32-23.04 55.68-23.04z m186.24 0.96256c17.92 0 33.28 3.2 46.08 9.6l-9.6 19.2c-12.16-6.4-24.32-9.6-36.48-9.6-16.64 0-30.39744 6.4-41.27744 19.2-10.24 12.16-15.36 29.44-15.36 51.84 0 23.04 4.79744 40.63744 14.39744 52.79744 9.6 11.52 23.68 17.28 42.24 17.28 10.24 0 23.36256-2.23744 39.36256-6.71744v19.2c-11.52 4.48-25.92256 6.71744-43.20256 6.71744-23.68 0-42.24-7.35744-55.68-22.07744-13.44-15.36-20.15744-38.08256-20.15744-68.16256 0-28.16 7.04-49.92 21.12-65.28 14.72-16 34.23744-23.99744 58.55744-23.99744z m-421.43744 1.92h48.95744c24.96 0 44.48256 7.68 58.56256 23.04 14.72 14.72 22.07744 35.84 22.07744 63.36 0 28.8-7.68 50.87744-23.04 66.23744-14.72 15.36-35.51744 23.04-62.39744 23.04h-44.16V500.96128z m478.08 0h23.99744l39.36256 67.2 40.32-67.2h23.04l-50.88256 83.51744 54.72256 92.16h-24.96l-43.20256-75.83744-43.19744 75.83744h-23.04l54.71744-92.16-50.87744-83.51744z m-242.88256 17.28c-17.28 0-30.39744 6.07744-39.35744 18.23744-8.96 11.52-13.44 28.8-13.44 51.84 0 23.68 4.48 41.6 13.44 53.76 8.96 11.52 22.07744 17.28 39.35744 17.28s30.40256-5.76 39.36256-17.28c8.96-12.16 13.44-30.08 13.44-53.76 0-23.04-4.48-40.32-13.44-51.84-8.96-12.16-22.08256-18.23744-39.36256-18.23744z m-213.12 1.92v137.27744h19.2c21.76 0 37.76-5.76 48-17.28 10.88-11.52 16.32256-28.8 16.32256-51.84s-5.12-39.99744-15.36-50.87744c-9.6-11.52-24.32-17.28-44.16-17.28h-24.00256z"
                  /></svg
              ></el-icon>
            </div>
          </div>
          <div class="dialog-row">
            <div class="dialog-label">{{ $t('operation.diagram') }}</div>
            <div class="icon-group">
              <el-icon @click="handleExport('SVG')"
                ><svg
                  class="icon"
                  width="200px"
                  height="200.00px"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#1296db"
                    d="M354.40128 0c-87.04 0-157.44 70.55872-157.44 157.59872v275.68128H78.72c-21.6576 0-39.36256 17.69984-39.36256 39.36256v236.31872c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.24128v118.08256c0 87.04 70.4 157.59872 157.44 157.59872h472.63744c87.04 0 157.59872-70.55872 157.59872-157.59872V315.0336c0-41.74848-38.9888-81.93024-107.52-149.27872l-29.11744-29.12256L818.87744 107.52C751.5392 38.9888 711.39328 0 669.59872 0H354.4064z m0 78.72h287.20128c28.35456 7.0912 27.99616 42.1376 27.99616 76.8v120.16128c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.07744c39.38816 0 78.87872-0.0256 78.87872 39.36256v512c0 43.32032-35.55328 78.87872-78.87872 78.87872H354.4064c-43.32544 0-78.72-35.5584-78.72-78.87872v-118.08256h393.91744c21.66272 0 39.36256-17.69472 39.36256-39.35744V472.64256c0-21.66272-17.69984-39.36256-39.36256-39.36256H275.68128V157.59872c0-43.32032 35.39456-78.87872 78.72-78.87872z m-115.2 426.72128c17.28 0 32.64 3.2 46.08 9.6l-7.68 18.23744c-13.44-5.76-26.24-8.63744-38.4-8.63744-10.24 0-17.92 2.23744-23.04 6.71744s-7.68 10.56256-7.68 18.24256c0 8.96 1.92 15.67744 5.76 20.15744 4.48 3.84 15.03744 9.6 31.67744 17.28 17.28 7.04 28.48256 14.40256 33.60256 22.08256 5.76 7.04 8.63744 16 8.63744 26.88 0 14.72-5.12 26.55744-15.36 35.51744s-24.96 13.44-44.16 13.44c-18.56 0-33.28-2.56-44.16-7.68v-21.12c15.36 6.4 30.08 9.6 44.16 9.6 12.8 0 22.08256-2.23744 27.84256-6.71744 6.4-4.48 9.6-11.52 9.6-21.12 0-7.68-2.24256-14.08-6.72256-19.2-3.2-3.2-15.03744-9.28256-35.51744-18.24256-13.44-6.4-23.04-13.44-28.8-21.12s-8.64256-17.59744-8.64256-29.75744c0-13.44 4.48-24.00256 13.44-31.68256 9.6-8.32 22.72256-12.47744 39.36256-12.47744z m295.68 0c17.92 0 33.92 3.2 48 9.6l-8.64256 20.15744c-14.08-7.04-27.83744-10.55744-41.27744-10.55744-18.56 0-33.28 6.07744-44.16 18.23744s-16.32256 29.76256-16.32256 52.80256c0 23.04 4.80256 40.63744 14.40256 52.79744 10.24 11.52 25.6 17.28 46.08 17.28 9.6 0 19.84-1.28 30.72-3.84v-51.84h-35.52256v-20.15744h57.6v86.4c-17.92 5.76-37.43744 8.63744-58.55744 8.63744-23.68 0-42.56256-7.68-56.64256-23.04s-21.12-37.76-21.12-67.2c0-28.16 7.36256-49.92 22.08256-65.28 15.36-16 36.48-23.99744 63.36-23.99744z m-235.20256 1.92h24.00256l35.51744 111.36c3.2 10.88 6.72256 24.32 10.56256 40.32 1.92-11.52 5.43744-25.28256 10.55744-41.28256l35.52256-110.39744h23.04L380.3136 683.03872H358.2464L299.6736 507.36128z"
                  /></svg
              ></el-icon>
              <el-icon @click="handleExport('PNG')"
                ><svg
                  class="icon"
                  width="200px"
                  height="200.00px"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#1296db"
                    d="M354.40128 0c-87.04 0-157.44 70.55872-157.44 157.59872v275.68128H78.72c-21.6576 0-39.36256 17.69984-39.36256 39.36256v236.31872c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.24128v118.08256c0 87.04 70.4 157.59872 157.44 157.59872h472.63744c87.04 0 157.59872-70.55872 157.59872-157.59872V315.0336c0-41.74848-38.9888-81.93024-107.52-149.27872l-29.11744-29.12256L818.87744 107.52C751.5392 38.9888 711.39328 0 669.59872 0H354.4064z m0 78.72h287.20128c28.35456 7.0912 27.99616 42.1376 27.99616 76.8v120.16128c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.07744c39.38816 0 78.87872-0.0256 78.87872 39.36256v512c0 43.32032-35.55328 78.87872-78.87872 78.87872H354.4064c-43.32544 0-78.72-35.5584-78.72-78.87872v-118.08256h393.91744c21.66272 0 39.36256-17.69472 39.36256-39.35744V472.64256c0-21.66272-17.69984-39.36256-39.36256-39.36256H275.68128V157.59872c0-43.32032 35.39456-78.87872 78.72-78.87872z m189.11744 420.32128c17.92 0 33.92 3.2 48 9.6l-8.63744 20.15744c-14.08-7.04-27.84256-10.55744-41.28256-10.55744-18.56 0-33.28 6.07744-44.16 18.23744s-16.31744 29.76256-16.31744 52.80256c0 23.04 4.79744 40.63744 14.39744 52.79744 10.24 11.52 25.6 17.28 46.08 17.28 9.6 0 19.84-1.28 30.72-3.84v-51.84h-35.51744v-20.15744h57.6v86.4c-17.92 5.76-37.44256 8.63744-58.56256 8.63744-23.68 0-42.55744-7.68-56.63744-23.04s-21.12-37.76-21.12-67.2c0-28.16 7.35744-49.92 22.07744-65.28 15.36-16 36.48-23.99744 63.36-23.99744z m-398.39744 1.92h43.19744c20.48 0 35.84 4.48 46.08 13.44 10.24 8.32 15.36 21.12 15.36 38.4s-5.43744 31.03744-16.31744 41.27744c-10.88 9.6-26.88 14.40256-48 14.40256h-18.24256v68.15744h-22.07744V500.96128z m142.08 0h25.91744l85.44256 144.95744h0.95744c-1.28-21.12-1.92-37.43744-1.92-48.95744v-96h21.12v175.67744H392.8064l-86.4-144.95744h-0.96256c1.28 23.04 1.92 39.68 1.92 49.92v95.03744h-20.15744V500.96128z m-120.00256 19.2v69.12h15.36c16 0 27.20256-2.88256 33.60256-8.64256 7.04-5.76 10.55744-14.72 10.55744-26.88 0-10.88-3.51744-19.2-10.55744-24.96-6.4-5.76-16.32256-8.63744-29.76256-8.63744h-19.2z"
                  /></svg
              ></el-icon>
              <el-icon @click="handleExport('JPG')"
                ><svg
                  class="icon"
                  width="20px"
                  height="20px"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#1296db"
                    d="M354.40128 0c-87.04 0-157.44 70.55872-157.44 157.59872v275.68128H78.72c-21.6576 0-39.36256 17.69984-39.36256 39.36256v236.31872c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.24128v118.08256c0 87.04 70.4 157.59872 157.44 157.59872h472.63744c87.04 0 157.59872-70.55872 157.59872-157.59872V315.0336c0-41.74848-38.9888-81.93024-107.52-149.27872l-29.11744-29.12256L818.87744 107.52C751.5392 38.9888 711.39328 0 669.59872 0H354.4064z m0 78.72h287.20128c28.35456 7.0912 27.99616 42.1376 27.99616 76.8v120.16128c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.07744c39.38816 0 78.87872-0.0256 78.87872 39.36256v512c0 43.32032-35.55328 78.87872-78.87872 78.87872H354.4064c-43.32544 0-78.72-35.5584-78.72-78.87872v-118.08256h393.91744c21.66272 0 39.36256-17.69472 39.36256-39.35744V472.64256c0-21.66272-17.69984-39.36256-39.36256-39.36256H275.68128V157.59872c0-43.32032 35.39456-78.87872 78.72-78.87872zM501.9136 499.04128c17.92 0 33.92 3.2 48 9.6l-8.63744 20.15744c-14.08-7.04-27.84256-10.55744-41.28256-10.55744-18.56 0-33.28 6.07744-44.16 18.23744s-16.31744 29.76256-16.31744 52.80256c0 23.04 4.79744 40.63744 14.39744 52.79744 10.24 11.52 25.6 17.28 46.08 17.28 9.6 0 19.84-1.28 30.72-3.84v-51.84H495.2064v-20.15744h57.6v86.4c-17.92 5.76-37.44256 8.63744-58.56256 8.63744-23.68 0-42.55744-7.68-56.63744-23.04s-21.12-37.76-21.12-67.2c0-28.16 7.35744-49.92 22.07744-65.28 15.36-16 36.48-23.99744 63.36-23.99744z m-287.03744 1.92h22.07744v172.8c0 16-4.15744 28.16-12.47744 36.48-8.32 8.96-20.16256 13.44-35.52256 13.44-7.04 0-13.11744-0.96256-18.23744-2.88256v-19.2c6.4 1.28 12.8 1.92 19.2 1.92 8.32 0 14.39744-2.23744 18.23744-6.71744 4.48-4.48 6.72256-11.20256 6.72256-20.16256V500.96128z m68.15744 0h43.20256c20.48 0 35.84 4.48 46.08 13.44 10.24 8.32 15.36 21.12 15.36 38.4s-5.44256 31.03744-16.32256 41.27744c-10.88 9.6-26.88 14.40256-48 14.40256h-18.23744v68.15744H283.0336V500.96128z m22.08256 19.2v69.12h15.36c16 0 27.19744-2.88256 33.59744-8.64256 7.04-5.76 10.56256-14.72 10.56256-26.88 0-10.88-3.52256-19.2-10.56256-24.96-6.4-5.76-16.31744-8.63744-29.75744-8.63744h-19.2z"
                  /></svg
              ></el-icon>
            </div>
          </div>
        </div>
      </el-dialog>
    </template>
  </HorizontalDraggableLayout>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import { ElInput, ElButton } from 'element-plus';
import { useAuth0 } from '@auth0/auth0-vue';
import { fetchLatestERDiagramData } from '@/api/apiService';
import { chatWithClassDiagram, exportDocx } from '@/api/apiService';
import ChatBubble from '@/components/ChatBubble.vue';
import CanvasContainer from '@/components/CanvasContainer.vue';
import MarkdownContent from '@/components/MarkdownContent.vue';
import HorizontalDraggableLayout from '@/components/HorizontalDraggableLayout.vue';
import ToolBar from '@/components/ToolBar.vue';
import { useDark } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { getInstrctionMessage } from '@/utils/errorParams';
import { getLocalTimeInfo } from '@/utils/utcDateTime';
import { ChatSquare, DeleteFilled } from '@element-plus/icons-vue';
import { ElDialog, ElIcon, ElMessage } from 'element-plus';
import { Canvg, presets } from 'canvg';
import logoImg from '@/assets/icons/deepseek_logo.webp';

export default {
  name: 'ClassDiagram',
  components: {
    ElInput,
    ElButton,
    ChatBubble,
    CanvasContainer,
    MarkdownContent,
    HorizontalDraggableLayout,
    ToolBar,
    // eslint-disable-next-line vue/no-unused-components
    ChatSquare,
    ElDialog,
    ElIcon,
  },
  setup() {
    const store = useStore();
    const viewGuide = computed(() => store.getters.viewGuide);
    const chatContainerRef = ref(null);
    const { user } = useAuth0();
    let erDiagramData = null;
    const textarea = ref('');
    const showCanvas = ref(true);
    const chatsContent = ref([]);
    const autosize = ref({ minRows: 1, maxRows: 6 });
    const openedTab = ref(null);
    const isMerged = ref(true);
    const loading = ref(false); // 添加 loading 状态
    const submitLoading = ref(false);
    const textareaRef = ref(null);
    const isDarkMode = useDark();
    const requestQuota = ref('');
    const requestQuotaData = ref('');
    const { t, locale } = useI18n();
    const dialogVisible = ref(false);
    const isSubmitButtonDisabled = computed(() => textarea.value.trim() === '');
    const textareaLength = computed(() => textarea.value.length);
    const isMaxLengthReached = computed(() => textareaLength.value >= 128);
    const toggleContent = () => {
      showCanvas.value = !showCanvas.value;
    };
    const { loginWithPopup, getAccessTokenSilently, isAuthenticated } = useAuth0();
    const userInfo = ref({});
    const showDialog = ref(false);
    let submitTimeout = null;
    let cleanupTimeout = null;
    let focusInput = null;
    let latestMessage = '';
    let sendingHandler = null;
    const messages = ref([
      t('helpMessage.line1'),
      t('helpMessage.line2'),
      t('helpMessage.line3'),
      t('helpMessage.line4'),
      t('helpMessage.line5'),
    ]);
    let messageIndex = 0;
    let fadeInterval = null;

    const currentMessage = ref('');

    const startFading = () => {
      fadeInterval = setInterval(() => {
        currentMessage.value = messages.value[messageIndex];
        messageIndex = (messageIndex + 1) % messages.value.length;
      }, 3000); // 每3秒切换一次消息
    };

    const handleMessageClick = () => {
      clearInterval(fadeInterval); // 清除当前的定时器
      messageIndex = (messageIndex + 1) % messages.value.length; // 切换到下一条消息
      currentMessage.value = messages.value[messageIndex]; // 更新当前消息
      startFading(); // 重新开始定时任务
    };

    const updateRequestQuota = () => {
      if (requestQuotaData.value) {
        const aa = getLocalTimeInfo(requestQuotaData.value.resetTimeUtcTimestamp);
        requestQuota.value = t('requestQuota', {
          remain: requestQuotaData.value.remain,
          total: requestQuotaData.value.total,
          time: `${aa.timeIn24} ${aa.timeZoneName}`,
          day: aa.isToday ? t('today') : t('tomorrow'),
        });
        if (requestQuotaData.value.avaliableRollBackCount == 0) {
          ElMessage.warning(t('noMoreRollback'));
        }
      }
    };

    const updateAutosize = () => {
      const pageHeight = window.innerHeight;
      const maxRows = Math.floor((pageHeight * 0.4) / 24); // 假设每行高度为24px
      autosize.value = { minRows: 1, maxRows };
    };

    const handleMessage = (event) => {
      if (event.data === 'tabClosed') {
        isMerged.value = true;
        openedTab.value = null;
      }
    };

    const viewDocument = () => {
      finishGuide();
      store.dispatch('navigateTo', '/document/class-diagram#limitation');
    };

    const finishGuide = () => {
      store.dispatch('setViewGuide', false);
    };
    const loadAll = async () => {
      loading.value = true; // 开始加载时显示遮罩
      window.addEventListener('resize', updateAutosize);
      updateAutosize();
      window.addEventListener('message', handleMessage);
      try {
        const accessToken = store.getters.accessToken;
        erDiagramData = await fetchLatestERDiagramData(accessToken, locale.value);
        setupSVG(erDiagramData.svgContent, erDiagramData.svgTitle);
        store.dispatch('updateOpenXMLContent', erDiagramData.openXMLDocument);
        requestQuotaData.value = erDiagramData.quotaInfo;
        updateRequestQuota();
      } catch (error) {
        console.error('Error fetching ER diagram data:', error);
        if (error.response?.status == 401) {
          showDialog.value = true;
        } else {
          ElMessage.error(t('loadingError'));
        }
      } finally {
        loading.value = false; // 加载完成或错误后隐藏遮罩
        startFading();
      }
    };

    const startFocus = () => {
      focusInput = setInterval(() => {
        if (textareaRef.value) {
          textareaRef.value.focus();
        }
      }, 2000);
    };

    onMounted(async () => {
      if (user.value == null) {
        showDialog.value = true;
      } else {
        loadAll();
        startFocus();
      }
      window.addEventListener('message', (event) => {
        if (event.origin !== window.location.origin) {
          return;
        }
        if (typeof event.data == 'string') {
          if (event.data == 'tabClosed') {
            updateMerge(true);
            openedTab.value = null;
            showCanvas.value = true;
          } else {
            event.source.postMessage(parentCallback(event.data), event.origin);
          }
        }
        return;
      });
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateAutosize);
      window.removeEventListener('message', handleMessage);
      if (focusInput) {
        clearInterval(focusInput);
      }
      clearInterval(fadeInterval);
    });

    const handleExport = async (type) => {
      dialogVisible.value = false;
      if (type == 'DOCX') {
        const fileName = 'class_diagram_demo.docx';
        const accessToken = store.getters.accessToken;
        const userName = user.value.nickname;
        const blob = await exportDocx(accessToken, locale.value, userName);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const svgContent = store.getters.getSvgContent;

        if (type === 'SVG') {
          const blob = new Blob([svgContent], { type: 'image/svg+xml' });
          const url = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'class_diagram_demo.svg'; // 文件名
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        } else {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          const v = await Canvg.from(ctx, svgContent, presets.offscreen());
          await v.render();

          let dataURL;
          if (type === 'PNG') {
            dataURL = canvas.toDataURL('image/png');
          } else if (type === 'JPG') {
            dataURL = canvas.toDataURL('image/jpeg', 1.0); // 1.0 is the quality (0.0 to 1.0)
          }

          const a = document.createElement('a');
          a.href = dataURL;
          a.download = `class_diagram_demo.${type.toLowerCase()}`; // 文件名
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    };

    const setupSVG = (svgContent, svgTitle) => {
      store.dispatch('updateSvgContent', svgContent);
      store.dispatch('updateSvgTitle', svgTitle);
    };

    const handleIconClick = (iconNumber) => {
      if (iconNumber === 3) {
        updateMerge(!isMerged.value);
      } else {
        dialogVisible.value = true;
      }
    };
    const updateMerge = (newIsMerged) => {
      isMerged.value = newIsMerged;
      store.dispatch('updateIsMerged', newIsMerged);
      if (newIsMerged) {
        if (openedTab.value) {
          openedTab.value.close();
          openedTab.value = null;
          showCanvas.value = true;
        }
      } else {
        showCanvas.value = false;
        openedTab.value = window.open(window.location.origin + '/tools/class-diagram-results', '_blank');
      }
    };
    const parentCallback = (data) => {
      return handleInput(data);
    };
    const sendText = (originText) => {
      // 检查去掉指令结尾后的内容是否为空
      if (originText.trim() == '') {
        // 如果为空，显示警告信息
        ElMessage.warning(t('chat.emptyInfoNotAllow'));
      } else {
        // 设置一个定时器，在 1000 毫秒后执行 handleSubmit()
        submitTimeout = setTimeout(() => {
          textarea.value = originText;
          handleSubmit();
          textarea.value = '';
        }, 800);
      }
    };

    const handleInput = (text) => {
      let originText = text.trim();
      text = originText.toLowerCase();
      const submitTextCN = t('chat.submit', {}, { locale: 'zh-CN' }).trim().toLowerCase();
      const submitTextEN = t('chat.submit', {}, { locale: 'en-US' }).trim().toLowerCase();
      const submitTextTW = t('chat.submit', {}, { locale: 'zh-TW' }).trim().toLowerCase();
      const cancelTextCN = t('chat.cancel', {}, { locale: 'zh-CN' }).trim().toLowerCase();
      const cancelTextEN = t('chat.cancel', {}, { locale: 'en-US' }).trim().toLowerCase();
      const cancelTextTW = t('chat.cancel', {}, { locale: 'zh-TW' }).trim().toLowerCase();
      const retryTextCN = t('chat.retry', {}, { locale: 'zh-CN' }).trim().toLowerCase();
      const retryTextEN = t('chat.retry', {}, { locale: 'en-US' }).trim().toLowerCase();
      const retryTextTW = t('chat.retry', {}, { locale: 'zh-TW' }).trim().toLowerCase();

      if (text.endsWith(submitTextCN)) {
        // 阻止默认的 'Enter' 键行为
        event.preventDefault();
        // 去掉指令结尾
        sendText(originText.slice(0, -submitTextCN.length));
        return '';
      } else if (text.endsWith(submitTextTW)) {
        // 阻止默认的 'Enter' 键行为
        event.preventDefault();
        // 去掉指令结尾
        sendText(originText.slice(0, -submitTextTW.length));
        return '';
      } else if (text.endsWith(submitTextEN)) {
        // 阻止默认的 'Enter' 键行为
        event.preventDefault();
        // 去掉指令结尾
        sendText(originText.slice(0, -submitTextEN.length));
        return '';
      } else if (text.endsWith(cancelTextCN) || text.endsWith(cancelTextTW) || text.endsWith(cancelTextEN)) {
        cleanupTimeout = setTimeout(() => {
          textarea.value = '';
        }, 800);
        clearTimeout(submitTimeout);
        return '';
      } else if (text.endsWith(retryTextCN || text.endsWith(retryTextTW) || text.endsWith(retryTextEN))) {
        submitTimeout = setTimeout(() => {
          textarea.value = latestMessage;
          handleSubmit();
          textarea.value = '';
        }, 800);
        return '';
      } else {
        if (submitTimeout != null) {
          clearTimeout(submitTimeout);
        }
        if (cleanupTimeout != null) {
          clearTimeout(cleanupTimeout);
        }
        return text;
      }
    };
    const handleKeyDown = (event) => {
      // 检查按下的键是否为 'Enter'，并且没有按下 Alt、Ctrl 或 Shift 键
      if (event.key === 'Enter' && !event.altKey && !event.ctrlKey && !event.shiftKey) {
        // 阻止默认的 'Enter' 键行为（通常是换行）
        event.preventDefault();

        // 检查输入框的内容是否为空（去掉前后空格后）
        if (textarea.value.trim() == '') {
          // 如果为空，显示警告信息
          ElMessage.warning(t('chat.emptyInfoNotAllow'));
        } else {
          // 如果不为空，调用提交函数
          handleSubmit();
        }
      }
      // 检查按下的键是否为 'Enter'，并且按下了 Ctrl 或 Alt 键
      else if (event.key === 'Enter' && (event.ctrlKey || event.altKey)) {
        // 阻止默认的 'Enter' 键行为
        event.preventDefault();

        // 在输入框中添加一个换行符
        textarea.value += '\n';
      }
      // 检查输入框的字符长度是否超过 128 个字符
      else if (textareaLength.value >= 128) {
        // 如果超过，截取前 127 个字符
        textarea.value = textarea.value.slice(0, 127);
      }
    };

    const messageAction = (buttonType, text) => {
      if (buttonType === 'copy') {
        textarea.value = text;
        textareaRef.value.focus();
      } else if (buttonType === 'retry') {
        textarea.value = text;
        handleSubmit();
      }
    };

    const handleClean = () => {
      textarea.value = '';
    };

    const goToHelpPage = () => {
      store.dispatch('setViewGuide', true);
    };

    const handleSubmit = async () => {
      const messageInfo = textarea.value.trim();
      latestMessage = messageInfo;
      if (submitLoading.value) return; // 如果已经在提交中，则直接返回
      if (requestQuotaData?.value == undefined || requestQuotaData?.value?.remain == 0) {
        ElMessage({
          message: t('outOfQuota'),
          type: 'warning',
        });
      }
      submitLoading.value = true;
      try {
        chatsContent.value = [];
        chatsContent.value = chatsContent.value.concat([
          {
            type: 'you',
            text: messageInfo,
          },
        ]);
        const accessToken = store.getters.accessToken;
        const payload = {
          userId: user.value.sub,
          message: messageInfo,
          cultureInfo: locale.value,
        };
        textarea.value = '';
        // 模拟添加正在处理信息
        sendingHandler = setTimeout(() => {
          chatsContent.value = [];
          chatsContent.value = chatsContent.value.concat([
            {
              type: 'info',
              text: t('chat.sending'),
            },
          ]);
        }, 3000);
        const a = await chatWithClassDiagram(payload, accessToken);
        erDiagramData = { ...a };
        if (sendingHandler) {
          clearTimeout(sendingHandler);
        }
        chatsContent.value = [];
        let messages = [];
        if (erDiagramData.stateCode != 'Success') {
          messages = messages.concat([
            {
              type: 'error',
              text: t('serverError.' + erDiagramData.stateCode.toLowerCase()),
            },
          ]);
        } else {
          setupSVG(erDiagramData.svgContent, erDiagramData.svgTitle);
          store.dispatch('updateOpenXMLContent', erDiagramData.openXMLDocument);

          // 处理未识别信息
          const warningMessages = erDiagramData.unrecognizedMessages
            ? erDiagramData.unrecognizedMessages.map((message) => ({
                type: 'warning',
                text: t('chat.unrecognizedMessage') + ':' + message,
              }))
            : [];
          messages = messages.concat(warningMessages);
          if (erDiagramData.instructionSuccessCount > 0) {
            messages = messages.concat([
              {
                type: 'info',
                text: t('actionsSuccess'),
              },
            ]);
          }
          var errors = erDiagramData.errorInfo.map((result) => {
            return {
              type: 'error',
              text: getInstrctionMessage(result.instructionType, result.resultType, result.params),
            };
          });
          messages = messages.concat(errors);
          requestQuotaData.value = erDiagramData.quotaInfo;
          updateRequestQuota();
          if (erDiagramData.clientOperations.length > 0) {
            const newIsMerged2 = !isMerged.value;
            switch (erDiagramData.clientOperations[0]) {
              case 'View|Split':
                if (newIsMerged2 == false) {
                  isMerged.value = newIsMerged2;
                  updateMerge(false);
                }
                break;
              case 'View|Merge':
                updateMerge(true);
                break;
              case 'Show|Doc':
                showCanvas.value = false;
                break;
              case 'Show|Diag':
                showCanvas.value = true;
                break;
              case 'Exp|DOC':
                handleExport('DOCX');
                break;
              case 'Exp|PNG':
                handleExport('PNG');
                break;
              case 'Exp|JPG':
                handleExport('JPG');
                break;
              case 'Exp|SVG':
                handleExport('SVG');
                break;
            }
          }
          // 无成功，无失败，无警告
          if (
            messages.length == 0 &&
            erDiagramData.clientOperations.length == 0 &&
            erDiagramData.unrecognizedMessages.length == 0
          ) {
            messages = messages.concat([
              {
                type: 'warning',
                text: t('actionInvalid'),
              },
            ]);
          }
        }
        chatsContent.value = messages;
      } catch (error) {
        if (sendingHandler) {
          clearTimeout(sendingHandler);
        }
        console.error('Error during chat submission:', error);
        if (error.response?.status == 401) {
          showDialog.value = true;
        } else {
          chatsContent.value = [];
          chatsContent.value = chatsContent.value.concat([
            {
              type: 'error',
              text: t('serverError.common'),
            },
          ]);
        }
      } finally {
        submitLoading.value = false;
        textareaRef.value.focus();
        nextTick(() => {
          if (chatContainerRef.value) {
            chatContainerRef.value.scrollTop = chatContainerRef.value.scrollHeight;
          }
        });
      }
    };

    const login = async () => {
      try {
        await loginWithPopup();
        // 登录成功后，手动更新用户信息
        if (user.value) {
          userInfo.value = { ...user.value };
        }
        // 获取访问令牌并存储在缓存中
        const accessToken = await getAccessTokenSilently();
        store.dispatch('setAccessToken', accessToken);
        showDialog.value = false;
        loadAll();
        startFocus();
      } catch (error) {
        localStorage.clear();
        sessionStorage.clear();
        store.dispatch('resetState');
      }
    };

    watch(
      () => store.getters.currentLanguage,
      () => {
        loadAll();
        startFocus();
      }
    );

    watch(
      () => store.getters.languageSelecting,
      (isSelecting) => {
        if (isSelecting) {
          if (focusInput) {
            clearInterval(focusInput);
          }
        } else {
          if (focusInput) {
            clearInterval(focusInput);
          }
          startFocus();
        }
      }
    );

    return {
      viewDocument,
      finishGuide,
      viewGuide,
      textarea,
      showCanvas,
      chatsContent,
      autosize,
      openedTab,
      isMerged,
      loading,
      submitLoading,
      textareaRef,
      textareaLength,
      isMaxLengthReached,
      requestQuota,
      isDarkMode,
      toggleContent,
      handleIconClick,
      handleSubmit,
      handleKeyDown,
      ChatSquare,
      DeleteFilled,
      isSubmitButtonDisabled,
      dialogVisible,
      handleExport,
      requestQuotaData,
      messageAction,
      handleInput,
      logoImg,
      goToHelpPage,
      handleClean,
      isAuthenticated,
      login,
      showDialog,
      currentMessage,
      handleMessageClick,
    };
  },
};
</script>

<style scoped>
.layout {
  height: calc(100vh - 88px);
}
.top {
  padding: 6px 0;
  font-size: 12px;
  color: #666;
}
.outQuota {
  background-color: antiquewhite;
}

.chat {
  flex: 1;
  padding: 5px;
  overflow-y: hidden;
}

.bottom {
  padding: 20px 20px 10px 20px;
}

.input-container {
  display: flex;
  color: #aaa;
}

.left {
  display: flex;
  flex-direction: column;
  flex: 1; /* 如果需要占据剩余空间 */
}
.el-input {
  flex: 1;
}

.submit-button {
  margin-left: 10px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  min-width: 1024px;
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.input-length-info {
  margin-top: 5px;
  font-size: 10px;
}

.input-length-info span {
  margin-right: 10px;
}

.input-length-info span:last-child {
  margin-right: 0;
}

.max-length-warning {
  color: red;
  float: left;
}

.length-counter {
  color: #ccc;
  float: right;
}

.transparent-input .el-input__inner {
  background-color: transparent;
}

.dark .transparent-input .el-input__inner {
  background-color: transparent !important;
}

:deep(.el-dialog) {
  border-radius: 10px;
  border: 6px solid #ccc;
  width: 290px;
}

:deep(.el-dialog__title) {
  font-size: 14px;
}

:deep(.el-dialog__header) {
  text-align: left;
  margin-top: -8px;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dialog-row {
  display: flex;
  align-items: center;
}

.dialog-label {
  width: 60px; /* Fixed width for the first column */
  font-size: 18px; /* Larger text size */
  text-align: center; /* Align text to the right */
  margin-right: 16px; /* Space between label and icons */
}

.icon-group {
  display: flex;
  gap: 8px;
  justify-content: flex-start; /* Align icons to the left */
}

.el-icon {
  cursor: pointer;
  font-size: 36px;
  margin: 0 6px;
}

.guide {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 4px 8px;
  position: absolute;
  font-size: 12px;
}

.input-area {
  bottom: 90px;
  left: 30px;
  width: 300px;
}

.help-area {
  bottom: 25px;
  left: 250px;
}

.limit-area {
  top: 115px;
  left: 100px;
}

.language-area {
  top: 60px;
  right: 180px;
  width: 100px;
}

.control-area {
  bottom: 50px;
  right: 80px;
  width: 250px;
}

.title-area {
  bottom: 50px;
  left: 450px;
}

.main-area {
  top: 130px;
  left: 500px;
  text-align: left;
}

.action-area {
  width: 370px;
  word-wrap: normal;
  word-break: break-word;
  padding: 10px;
}

.powered {
  font-size: 10px;
  color: #888;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.url {
  margin-left: 3px;
}

.help {
  font-size: 12px;
  color: #888;
  padding: 4px;
}

.help:hover {
  border-radius: 16px;
  color: #fff;
  background-color: #777;
  font-weight: 700;
  cursor: pointer;
}

.info {
  font-size: 12px;
  vertical-align: text-top;
  margin-left: 0px;
}

.restiction {
  color: var(--el-bg-color);
  font-style: italic;
  text-decoration: underline;
}

.fitScreen-area {
  top: 120px;
  right: 30px;
  width: 140px;
}

.helper {
  position: relative;
  height: 20px; /* 设置消息容器的高度 */
  overflow: hidden;
  flex-grow: 1;
}

.helper:hover {
  cursor: pointer;
}

.message {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  line-height: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
